export default function useFilterInit() {

    const handleInit = ({ key }) => {
        switch (key.toUpperCase()) {
            case 'PAGAMENTO PARCIAL':
                return ["Pagamento Parcial"]
            case 'FINALIZADOS *':
                return ["Finalizado"]
            case 'TOTAL EM ABERTO':
                return ["Em Aberto"]
            case 'ACORDOS EM ANDAMENTO':
                return ["Em acordo"]
            case 'ACORDOS QUITADOS':
                return ["Acordo Quitado"]
            case 'BAIXA - PGTO DIRETO':
                return ["Pagamento direto"]
            case 'RESULTADOS *':
                return ["Em acordo", "Acordo Quitado", "Pagamento direto"]
            case 'Credor Inativo':
                return ["cobrança indevida"]
            case 'SEM COMISSÃO':
                return ["cobrança indevida"]
            case 'DEVOLUÇÃO DE MERCADORIA':
                return ["DEVOLUÇÃO DE MERCADORIA"]
            default:
                return ["Finalizado"]
        }
    }

    return {
        handleInit
    }

}